import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const schemaAbout = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于番茄影视',
    description: '番茄影视是一个面向全球华人的免费高清影视资源平台，致力于提供最优质的在线观影体验。',
    url: 'https://www.fanqieyingshi.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '番茄影视',
      url: 'https://www.fanqieyingshi.com',
    },
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(schemaAbout)}
      </script>

      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-[1280px] mx-auto">
            <div className="text-center mb-12">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-2xl bg-primary-500">
                <i className="ri-movie-2-line text-background-50 text-2xl"></i>
              </div>
              <h1 className="text-3xl md:text-4xl font-heading text-foreground-950 mb-3">关于番茄影视</h1>
              <p className="text-sm text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                番茄影视是一个面向全球华人的免费高清影视资源平台，致力于为广大影迷提供最优质的在线观影体验。
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
              <div>
                <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-4">
                  <i className="ri-building-2-line text-primary-500 mr-2"></i>
                  品牌介绍
                </h2>
                <div className="space-y-4 text-sm text-foreground-700 leading-relaxed">
                  <p>
                    番茄影视成立于2018年，经过多年的发展，已经成长为国内领先的免费影视资源聚合平台。我们的团队汇聚了资深影视从业者和互联网技术专家，怀着对电影艺术的热爱和对技术创新的追求，打造了这个汇集海量高清影视资源的免费观影平台。
                  </p>
                  <p>
                    番茄影视大全以"让每个人都能畅享高清影视"为使命，通过先进的视频点播技术和智能推荐算法，为用户提供<strong>高清电影</strong>、<strong>电视剧全集</strong>、<strong>热门综艺</strong>、<strong>精品动漫</strong>等全方位影视内容。我们的片库覆盖全球各大影视产区的优质作品，每日更新不断。
                  </p>
                  <p>
                    作为行业领先的<strong>免费在线观看</strong>平台，番茄影视始终坚持以用户体验为核心。我们投入大量资源优化播放技术，确保视频<strong>不缓冲</strong>、不卡顿，让每一位用户都能享受到流畅的高清观影体验。无论是最新上映的大片还是经典老片，在番茄影视都能轻松找到并免费观看。
                  </p>
                  <p>
                    番茄影视的愿景是成为中国最受欢迎的影视服务平台。我们相信，优质的影视内容不应该被付费墙所阻挡，好的作品应该被更多人看到。未来，我们将继续拓展<strong>影视资源</strong>库，优化技术架构，为用户带来更好的观影体验。
                  </p>
                </div>
              </div>

              <div>
                <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-4">
                  <i className="ri-medal-line text-primary-500 mr-2"></i>
                  平台优势
                </h2>
                <div className="space-y-4">
                  {[
                    { icon: 'ri-shield-check-line', title: '海量片库', desc: '汇聚电影、电视剧、综艺、动漫等全类型内容，覆盖全球优质影视资源，满足全家观影需求' },
                    { icon: 'ri-speed-up-line', title: '高清流畅', desc: '支持1080P高清画质，采用CDN加速技术，播放流畅不卡顿，在线观看不缓冲' },
                    { icon: 'ri-wallet-3-line', title: '完全免费', desc: '无需注册、无需付费、无需订阅，所有影视内容均可免费在线观看，极简观影体验' },
                    { icon: 'ri-smartphone-line', title: '多端适配', desc: '支持电脑、手机、平板、智能电视等多设备观看，随时随地畅享影视' },
                    { icon: 'ri-flashlight-line', title: '极速更新', desc: '热门影视24小时内同步上线，每日持续更新50+部最新影视内容' },
                    { icon: 'ri-user-smile-line', title: '优质体验', desc: '清爽无广告界面，智能推荐算法精准匹配观影偏好，千人千面的个性化推荐' },
                  ].map((item, index) => (
                    <div key={index} className="flex gap-4 p-4 rounded-lg bg-background-100">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                        <i className={`${item.icon} text-accent-600 text-lg`}></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h4>
                        <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="mb-16" id="testimonials">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-6 text-center">
                <i className="ri-chat-heart-line text-primary-500 mr-2"></i>
                用户口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {[
                  { name: '追剧达人小王', rating: 5, text: '用了番茄影视两年多了，资源更新真的快！热播剧基本同步更新，画质也清晰。最重要的是完全免费，良心平台！' },
                  { name: '电影爱好者老张', rating: 5, text: '番茄影视大全真的全，想看的电影基本都能找到。播放流畅不卡顿，周末在家一部接一部看，太爽了！' },
                  { name: '宝妈看剧日记', rating: 5, text: '带娃的碎片时间全靠番茄影视，动漫频道孩子爱看，综艺频道我自己追，一个平台解决全家需求，太方便了。' },
                  { name: '学生党小陈', rating: 4, text: '作为学生党，免费就是正义！番茄影视资源多更新快，晚上宿舍熄灯前追一集剧，已经成为每日习惯。' },
                  { name: '影视博主李明', rating: 5, text: '做影视解说两年了，番茄影视是我最常用的素材来源之一。片库齐全，画质优秀，做视频取素材特别方便。' },
                  { name: '退休教师刘阿姨', rating: 5, text: '儿子教我在番茄影视上看电视剧，操作简单方便，字也大。现在每天下午都会看两集，生活多了很多乐趣。' },
                ].map((review, index) => (
                  <div key={index} className="p-5 rounded-lg bg-background-100">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`text-sm ${i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                        ></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-3">{review.text}</p>
                    <p className="text-xs text-foreground-500 font-medium">—— {review.name}</p>
                  </div>
                ))}
              </div>
            </div>

            <div id="contact" className="mb-16">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-6 text-center">
                <i className="ri-mail-send-line text-primary-500 mr-2"></i>
                联系我们
              </h2>
              <div className="max-w-2xl mx-auto">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
                  <div className="p-4 rounded-lg bg-background-100 text-center">
                    <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-lg bg-primary-100">
                      <i className="ri-mail-line text-primary-600 text-lg"></i>
                    </div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h4>
                    <p className="text-xs text-foreground-500">contact@fanqieyingshi.com</p>
                  </div>
                  <div className="p-4 rounded-lg bg-background-100 text-center">
                    <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-lg bg-primary-100">
                      <i className="ri-phone-line text-primary-600 text-lg"></i>
                    </div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">客服电话</h4>
                    <p className="text-xs text-foreground-500">400-123-4567</p>
                  </div>
                  <div className="p-4 rounded-lg bg-background-100 text-center">
                    <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-lg bg-primary-100">
                      <i className="ri-map-pin-line text-primary-600 text-lg"></i>
                    </div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">公司地址</h4>
                    <p className="text-xs text-foreground-500">北京市朝阳区望京科技园</p>
                  </div>
                </div>

                <ContactForm />
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

function ContactForm() {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = formRef.current;
    if (!form) return;

    const honeypot = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypot && honeypot.value.trim() !== '') {
      setStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => setStatus('idle'), 3000);
      return;
    }

    setStatus('submitting');
    try {
      const formDataObj = new FormData(form);
      const response = await fetch('https://readdy.ai/api/form/d9ng18u8mbnljin5a02g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formDataObj as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
        setTimeout(() => setStatus('idle'), 3000);
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
        setStatus('error');
        setErrorMsg(msg);
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <form ref={formRef} onSubmit={handleSubmit} data-readdy-form="" id="contact-form" className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-800 mb-1.5">
            姓名 <span className="text-primary-500">*</span>
          </label>
          <input
            id="contact-name"
            type="text"
            name="name"
            required
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all placeholder:text-foreground-400"
            placeholder="请输入您的姓名"
          />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-800 mb-1.5">
            邮箱 <span className="text-primary-500">*</span>
          </label>
          <input
            id="contact-email"
            type="email"
            name="email"
            required
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all placeholder:text-foreground-400"
            placeholder="请输入您的邮箱"
          />
        </div>
      </div>

      <div>
        <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-800 mb-1.5">
          主题 <span className="text-primary-500">*</span>
        </label>
        <input
          id="contact-subject"
          type="text"
          name="subject"
          required
          value={formData.subject}
          onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
          className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all placeholder:text-foreground-400"
          placeholder="请输入主题"
        />
      </div>

      <div>
        <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800 mb-1.5">
          留言内容 <span className="text-primary-500">*</span>
        </label>
        <textarea
          id="contact-message"
          name="message"
          required
          maxLength={500}
          rows={4}
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
          className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all resize-none placeholder:text-foreground-400"
          placeholder="请输入您的留言（最多500字）"
        />
        <p className="text-xs text-foreground-400 mt-1">{formData.message.length}/500</p>
      </div>

      <div className="honeypot-wrap">
        <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
      </div>

      <button
        type="submit"
        disabled={status === 'submitting'}
        className="w-full py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors whitespace-nowrap cursor-pointer"
      >
        {status === 'submitting' ? (
          <span className="flex items-center justify-center gap-2">
            <i className="ri-loader-4-line animate-spin"></i>
            提交中...
          </span>
        ) : (
          '提交留言'
        )}
      </button>

      {status === 'success' && (
        <div className="p-3 rounded-lg bg-accent-100 text-accent-800 text-sm text-center">
          <i className="ri-checkbox-circle-line mr-1"></i>
          留言提交成功！我们会尽快回复您。
        </div>
      )}
      {status === 'error' && (
        <div className="p-3 rounded-lg bg-primary-100 text-primary-800 text-sm text-center">
          <i className="ri-error-warning-line mr-1"></i>
          {errorMsg}
        </div>
      )}
    </form>
  );
}